import { getProductSearchByID } from "../../services/MainService";
const state = {
  overview: [],
  detailView: [],
  url: "",
  ovProductID: "",
  dvProductID: "",
  categoryOvTitle: "",
  categoryDvTitle: "",
  categoryTitle: "",
  seoID: ""
};
const getters = {
  productOverview: (state) => state.overview,
  productdetailView: (state) => state.detailView,
  url: (state) => state.url,
  ovProductID: (state) => state.ovProductID,
  dvProductID: (state) => state.dvProductID,
  categoryOvTitle: (state) => state.categoryOvTitle,
  categoryDvTitle: (state) => state.categoryDvTitle,
  categoryTitle: (state) => state.categoryTitle,
  seoID: (state) => state.seoID,
};
const mutations = {
  setOverview(state, res) {
    state.overview = res.data;
    state.url = res.data.displayType;
    state.categoryOvTitle = res.data.categoryInformation.categoryTitle;
    state.categoryTitle = res.data.categoryInformation.categoryTitle;
    state.seoID = res.data.seoID;
  },
  setOvProductId(state, res) {
    state.ovProductID = res;
  },
  setDetailView(state, res) {
    state.detailView = res.data;
    state.url = res.data.displayType;
    state.categoryDvTitle = res.data.categoryDetailInformation.title;
    state.categoryTitle = res.data.categoryDetailInformation.title;
    state.seoID = res.data.seoID;
  },
  setDvProductId(state, res) {
    state.dvProductID = res;
  },
};
const actions = {
  async fetchProductByID({ commit }, productID) {
    const response = await getProductSearchByID(productID);
    const displayType = response.data.displayType;
    if (displayType == "categoryOverview") {
      commit("setOverview", response);
      commit("setOvProductId", productID);
    }
    if (displayType == "categoryDetailView") {
      commit("setDetailView", response);
      commit("setDvProductId", productID);
    }

    // record interaction for data tracking
    const interactionData = {
      eventType: "displayProduct",
      eventData: {
        displayType: displayType,
        productID: productID
      }
    };

    this.dispatch('recordInteraction', interactionData, { root: true })

  },
  // async fetchPageContentForURLPath({commit}, productID) {
  //   const response = await getPageContentForURLPath("Leichtgewicht-Rollator");
  //   commit
  // }
};
export default {
  state,
  getters,
  actions,
  mutations,
};
